export default "__VITE_ASSET__NIrSg5Av__"